import React, { useContext, useEffect } from 'react';
import {
	Header,
	Page,
	PageAuth,
	PageHeader,
	PERMISSIONS,
	Sidebar,
	SideMenu,
	PageContainer,
	GlobalAlert,
	Filters,
} from '../..';
import { CASINO_GAME_PARTNERS_SEARCH_TYPES, gamesPages, useStore } from '../../../common';
import { Pagination, Table } from 'esa-ui-library';
import styles from './GamePartners.module.scss';
import { AuthContext } from '../../../logic';
import { PropertyType } from 'esa-ui-library/lib/types';
import { getRows } from './RowProvider';
import { gamePartnersListMap } from './GamePartners.const';
import { SearchFilter } from '../../components/Filters/components';
import { filterSearchOptionsByEnv } from '../Games/Games.helper';

const GamePartners = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const { gamePartners, rows, bulkRows, columns, pagesTotal, currentPage, gamePartnersLoading, perPage = '10' } = state;
	const { token } = useContext(AuthContext);
	// const [setEditModal] = useState(false);
	const filteredGamePartnersFields = gamePartnersListMap;

	const setColumnsConfig = (columns: PropertyType[]) =>
		columns.map((c) => {
			return {
				...c,
				cellClassName: c.position ? styles[c.position] : '',
			};
		});

	const addBulkAll = () => {
		return [
			// <Checkbox
			// 	disabled
			// 	key={uuid()}
			// 	checked={allRowsSelected}
			// 	partial={!!bulkRows.length && !allRowsSelected}
			// 	onChange={onBulkAllChange}
			// 	dataId='bulk-check'
			// />,
			...setColumnsConfig(filteredGamePartnersFields),
			'',
		];
	};

	const onAction = (type: string, gamePartner: PropertyType) => {
		switch (type) {
			case 'edit':
				dispatch('SELECT_GAME_PARTNER', { gamePartner });
				// setEditModal(true);
				break;
			default:
				break;
		}
	};

	useEffect(() => {
		dispatch('LOADING', false);
		dispatch('GAME_PARTNERS_INIT', { token, currentPage, perPage });
	}, []);

	const onPageChange = (page: number | string) => {
		dispatch('LOADING', true);
		dispatch('PAGE_UPDATE', { token, page, perPage });
	};

	useEffect(() => {
		dispatch('UPDATE_COLUMNS', addBulkAll());
	}, [gamePartners, bulkRows]);

	useEffect(() => {
		dispatch('UPDATE_ROWS', getRows(gamePartners, columns, onAction));
	}, [gamePartners, columns]);

	const onPerPageChange = (value: PropertyType) => {
		const perPage = value[0].value;
		dispatch('LOADING', true);
		dispatch('PER_PAGE', perPage);
		dispatch('PAGE_UPDATE', { token, currentPage, perPage });
	};
	return (
		<>
			<Header dataId='header' />
			<PageAuth onlyAdmin permission={PERMISSIONS.canViewOwnDetails}>
				<PageContainer>
					<Sidebar dataId='admin-sidebar'>
						<SideMenu options={gamesPages} title='Game Partners' />
					</Sidebar>
					<Page>
						<PageHeader title='Casino Game Partners'>
							{/*{user?.permissions?.isSuperAdmin ? (*/}
							{/*	<Button dataId='create-user' primary small onClick={onAddGamePartner}>*/}
							{/*		<PlusLight className={styles.AddUserIcon} />*/}
							{/*		Create Game Partner*/}
							{/*	</Button>*/}
							{/*) : null}*/}
						</PageHeader>
						<section className={styles.PageContent}>
							<Filters>
								<div style={{ marginLeft: 'auto' }}>
									<SearchFilter searchTypes={filterSearchOptionsByEnv(CASINO_GAME_PARTNERS_SEARCH_TYPES)} />
								</div>
							</Filters>
							{(!!gamePartners?.length || gamePartnersLoading) && (
								<>
									<Table
										titles={columns}
										data={rows}
										className={styles.GamePartnersTable}
										rowClassName={styles.GamePartnersRow}
										isLoading={gamePartnersLoading}
									/>
									<Pagination
										total={Math.ceil(pagesTotal / +perPage)}
										current={currentPage}
										onChange={onPageChange}
										perPage={perPage}
										showPerPage
										onPerPage={onPerPageChange}
									/>
								</>
							)}
							{/*{editModal && (*/}
							{/*	<Modal*/}
							{/*		title={selectedGamePartner ? 'Edit Game Partner' : 'Create Game Partner'}*/}
							{/*		submitLabel={SAVE}*/}
							{/*		primary*/}
							{/*		onCancel={onCloseCreateModal}*/}
							{/*		onSubmit={onSubmit}*/}
							{/*		loading={loading}*/}
							{/*	>*/}
							{/*		<CreateGamePartnerForm isEdit={!!selectedGamePartner} />*/}
							{/*	</Modal>*/}
							{/*)}*/}
						</section>
					</Page>
				</PageContainer>
				<GlobalAlert />
			</PageAuth>
		</>
	);
};

export { GamePartners };
